import { useGetComponentsQuery, ComponentInfoFragment } from 'gqlTypes'

// This is a valid use case to narrow down Component type
// eslint-disable-next-line no-restricted-imports
import { LayerStyle } from 'gqlTypes/expansiveTypes'

import { useGetIdentifiers } from './useGetIdentifiers'

const isLayerStyleComponent = (
  component?: ComponentInfoFragment
): component is LayerStyle => component?.__typename === 'LayerStyle'

export const useGetLayerStyles = (search?: string) => {
  const { shareIdentifier, versionShortId } = useGetIdentifiers()
  const { loading, data, refetch, fetchMore } = useGetComponentsQuery({
    variables: {
      shareIdentifier,
      versionShortId,
      type: 'LAYER_STYLE',
      search,
    },
  })

  return {
    loading,
    filter: (path: string | null) => refetch({ path }),
    fetchMore,
    entries:
      data?.share?.version?.document?.components.entries.filter(
        isLayerStyleComponent
      ) || [],
    meta: data?.share?.version?.document?.components.meta,
  }
}
